import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { nullifyNonnullableForDispose as e } from "./maybe.js";
import s from "./ObjectPool.js";

var t = /*#__PURE__*/function (_s) {
  _inherits(t, _s);

  var _super = _createSuper(t);

  function t() {
    var _this;

    _classCallCheck(this, t);

    _this = _super.apply(this, arguments), _this._set = new Set();
    return _this;
  }

  _createClass(t, [{
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(t.prototype), "destroy", this).call(this), this._set = e(this._set);
    }
  }, {
    key: "acquire",
    value: function acquire() {
      var _get2;

      for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
        e[_key] = arguments[_key];
      }

      var s = (_get2 = _get(_getPrototypeOf(t.prototype), "acquire", this)).call.apply(_get2, [this].concat(e));

      return this._set.delete(s), s;
    }
  }, {
    key: "release",
    value: function release(e) {
      e && !this._set.has(e) && (_get(_getPrototypeOf(t.prototype), "release", this).call(this, e), this._set.add(e));
    }
  }, {
    key: "_dispose",
    value: function _dispose(e) {
      this._set.delete(e), _get(_getPrototypeOf(t.prototype), "_dispose", this).call(this, e);
    }
  }]);

  return t;
}(s);

export { t as ReentrantObjectPool };